import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '../../icon/icon';
import { InternalLink } from '../../internal_link/internal_link';
import styles from './snapshot_item.css';

/**
 * SnapshotItem component for Snapshot Containers
 * @param {String} identifier The data id identifier
 * @param {String} href The href for the link
 * @param {String|Bool} label The label for the link (sometimes will be a boolean when label is passed as false)
 * @param {String} iconVariant The icon variant for Icon component
 * @return {Node} SnapshotItem returns SnapshotItem component
 */
const SnapshotItem = ({ identifier, href, label, iconVariant, onClick }) => {
    if (!label) return null;
    const labelElement = <span className={styles.label}>{label}</span>;
    return href && identifier ? (
        <div className={styles.container}>
            <InternalLink variant="variant_full_width" href={href} data-id={`SnapshotLink.${identifier}`} onClick={onClick}>
                <Icon className={styles.icon} variant={iconVariant} />
                {labelElement}
            </InternalLink>
        </div>
    ) : labelElement;
};

SnapshotItem.propTypes = {
    identifier: PropTypes.string,
    href: PropTypes.string,
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    iconVariant: PropTypes.string,
    onClick: PropTypes.func
};

SnapshotItem.defaultProps = {
    iconVariant: 'ctm_pencil'
};

export { SnapshotItem };
